import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environment/environment'; 
import { Observable } from 'rxjs';
import { ProjectInfo } from '../all-query-table/all-query-table.component';
import { BannerResponse } from '../../models/user-info.model';
import { GetFilterQueryResponse } from '../../models/filter-payload.model';

@Injectable({
  providedIn: 'root'
})
export class LandingPageApiService {

  public baseUrl = environment.backendApiConfiguration.api_url;

  constructor(private http: HttpClient) {}

  getMyProjects(): Observable<ProjectInfo[]> {
    const endpointUrl = `${this.baseUrl}home/my-projects`;


    return this.http.get<ProjectInfo[]>(endpointUrl);
  }
  getAllProjects(): Observable<ProjectInfo[]> {
    const endpointUrl = `${this.baseUrl}home/all-projects`;
    return this.http.get<ProjectInfo[]>(endpointUrl);
  }

  getBanner(): Observable<BannerResponse> {
  const url = `${this.baseUrl}Config/banner`;
  return this.http.get<BannerResponse>(url);
}

 searchFilters(searchTerm: string, isTemplate: boolean): Observable<any[]> {
  return this.http.get<any[]>(`${this.baseUrl}FilterQuery/SearchFilters`, {
    params: { searchTerm, isTemplate: isTemplate.toString() }
  });
}


}

